import { ArrowRight, ChevronDown } from "lucide-react";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxicmlnaHQlMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzgxMTg4MzE1fDA&ixlib=rb-4.1.0&q=85&w=2400";

function getRefFromCookie() {
  if (typeof document === "undefined") return "";
  const m = document.cookie.match(/(?:^|; )vg_ref=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
}

function withRef(path) {
  const ref = getRefFromCookie();
  return ref ? `${path}${path.includes("?") ? "&" : "?"}ref=${encodeURIComponent(ref)}` : path;
}

export default function Hero() {
  const primary = withRef("/orizzonti");
  const secondary = "/app";
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <img
        src={HERO_IMAGE}
        alt="Interno di una casa italiana luminosa con luce naturale calda"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      {/* Gradient overlay (bottom-up dark) */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/70" />
      <div className="absolute inset-0 bg-black/15" />

      {/* Content */}
      <div className="relative z-10 max-w-[1200px] w-full mx-auto px-6 md:px-8 py-32 md:py-40 flex flex-col items-center text-center">
        <span
          data-testid="hero-badge"
          className="inline-flex items-center gap-2 text-white/95 text-xs md:text-sm font-medium tracking-wide uppercase border border-white/30 rounded-full px-4 py-1.5 mb-8 backdrop-blur-sm bg-white/5"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-[#B40101]" />
          Strumenti gratuiti per proprietari di casa
        </span>

        <h1
          data-testid="hero-headline"
          className="font-display font-extrabold text-white text-4xl sm:text-5xl md:text-6xl lg:text-[64px] leading-[1.05] tracking-tight max-w-4xl"
        >
          Tre analisi per decidere cosa fare del tuo immobile, prima che un errore costi tempo e denaro.
        </h1>

        <p
          data-testid="hero-subtitle"
          className="mt-6 md:mt-8 text-white/85 text-lg md:text-xl max-w-2xl leading-relaxed font-light"
        >
          Chiarisci ciò che vuoi ottenere, comprendi il potenziale dell&apos;immobile e verifica cosa potrebbe rallentarti. Puoi utilizzare un solo strumento oppure completare l&apos;intero percorso.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
          <a
            data-testid="hero-cta-button"
            href={primary}
            className="inline-flex items-center gap-3 bg-[#B40101] hover:bg-[#8E0101] text-white font-semibold text-base md:text-lg px-7 py-4 rounded-xl transition-all duration-200 hover:-translate-y-0.5 shadow-[0_10px_30px_rgba(180,1,1,0.35)] hover:shadow-[0_14px_40px_rgba(180,1,1,0.5)]"
          >
            Inizia da OrizzontiPro <ArrowRight className="w-5 h-5" />
          </a>
          <a
            data-testid="hero-cta-secondary"
            href={secondary}
            className="inline-flex items-center gap-3 bg-white/10 hover:bg-white/20 text-white font-semibold text-base md:text-lg px-7 py-4 rounded-xl transition-all duration-200 hover:-translate-y-0.5 border border-white/30 backdrop-blur-sm"
          >
            Scegli il tuo punto di partenza
          </a>
        </div>

        <p data-testid="hero-cta-subtext" className="mt-4 text-white/80 text-sm max-w-2xl">
          Gratis. Nessuna registrazione. Ogni analisi completa arriva via email. Nessuna telefonata parte senza la tua richiesta.
        </p>
      </div>

      {/* Scroll arrow */}
      <button
        data-testid="hero-scroll-arrow"
        aria-label="Scorri verso il basso"
        onClick={() => {
          const el = document.getElementById("come-funziona");
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/90 hover:text-white vg-bounce"
      >
        <ChevronDown className="w-7 h-7" strokeWidth={2.4} />
      </button>
    </section>
  );
}
